import { showToast } from "./toastUtils";
import api from "./apiInterceptor";

// Base API URL - this should be set to your actual API endpoint
const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Fetch companies list
 * @returns {Promise<Array>} List of companies
 */
export const fetchCompanies = async () => {
  try {
    // Using the original working endpoint
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/profile/director-companies`;

    const response = await api.get(apiUrl);

    // Handle the specific structure with status, message and data fields
    if (response.status === 200 && response.data) {
      return response.data;
    } else {
      showToast(response.message || "Invalid company data format");
      return [];
    }
  } catch (error) {
    console.error("Error fetching companies:", error);
    // Toast is already shown by the interceptor
    return [];
  }
};

/**
 * Fetch company details by ID
 * @param {string} companyId - The ID of the company to fetch
 * @returns {Promise<Object>} Company details
 */
export const fetchCompanyDetails = async (companyId) => {
  try {
    // Using the original working endpoint
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/profile/company-access/${companyId}`;

    const response = await api.get(apiUrl);

    console.log("Company Access", response.data);

    // Handle the specific structure with status, message and data fields
    if (response.status === 200 && response.data) {
      return response.data;
    } else {
      showToast(response.message || "Invalid company details format");
      return null;
    }
  } catch (error) {
    console.error("Error fetching company details:", error);
    // Toast is already shown by the interceptor
    return null;
  }
};

/**
 * Get company tokens (access token and refresh token) for a company
 * @param {string} companyId - The ID of the company
 * @returns {Promise<Object>} Company tokens
 */
export const getCompanyTokens = async (companyId) => {
  try {
    // Using the original working endpoint
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/profile/company-access/${companyId}`;

    const response = await api.get(apiUrl);

    if (response.status === 200 && response.data) {
      return {
        accessToken: response.data.access_token,
        refreshToken: response.data.refresh_token,
        companyInfo: {
          id: companyId,
          name: response.data.name || "Company",
        },
      };
    } else {
      showToast(response.message || "Failed to get company tokens");
      return null;
    }
  } catch (error) {
    console.error("Error getting company tokens:", error);
    // Toast is already shown by the interceptor
    return null;
  }
};
